module.exports = __webpack_public_path__ + "static/media/travisgo_bg_businesspartner@1x.c12d2143.jpg";